export class Mail {
  toAddress: string;
  html?: string;
  url?:string;

  constructor(toAddress: string, html: string) {
    this.toAddress = toAddress;
    this.html = html;
    this.url="";
  }
}
